import { ReactComponent as Check } from './share-check.svg'
import { ReactComponent as CheckIn } from './checkIn.svg'
import { ReactComponent as Mail } from './share-mail.svg'

export const Icons = {
  Check,
  CheckIn,
  Mail
} 